<template>
  <ABackDrop :isVisible="isVisible">
    <div class="dialog">
      <slot name="content"></slot>
      <div class="actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </ABackDrop>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { ABackDrop } from '@atoms';

const props = defineProps({
  isVisible: Boolean,
});

const isVisible = toRef(props, 'isVisible');
</script>

<style scoped lang="scss">
.dialog {
  @apply bg-white p-20 rounded-2xl;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  padding: 80px 0 60px 0;
}
.dialog::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  border-bottom: 20px solid var(--main-color);
  z-index: 1;
}
.dialog::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20px;
  border-top: 20px solid var(--main-color);
  z-index: 1;
}

/*모바일*/
@media (min-width: 320px) and (max-width: 1279px) {
  .dialog {
    padding: 42px 0 40px 0;
  }
  .dialog::before {
    border-bottom: 10px solid var(--main-color);
  }
  .dialog::after {
    border-top: 10px solid var(--main-color);
  }
}
</style>
